<template>
  <BaseCard gray>
    <BaseCheckbox
      v-model="formData.settings.communication.appointmentNoShow"
      :label="$t('admin.calendar.no_show_label')"
      :description="$t('admin.calendar.no_show_description')"
      v-test="'no-show-checkbox'"
    />
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  formData: any;
}>();
</script>
